import React, { useState } from 'react';
import axios from 'axios';
import { Button, TextField, Typography, InputAdornment } from "@mui/material";
import toast from "react-hot-toast";
import { validateEmail } from '../functions/validators/validateEmail';

const Subscribe = () => {
    const [email, setEmail] = useState("");

    const handleSubscribe = async (e) => {
        e.preventDefault();
        try {
            if (!validateEmail(email)) {
                toast.error("Invalid email format");
            } else {
                const response = await axios.post("/api/v1/subscriber/subscribe", { email });
                toast.success(response.data.message);
                setEmail("");
            }
        }
        catch (err) {
            if (err.response && err.response.status === 400) {
                toast.error(err.response.data.message || "Email already exists");
            } else {
                toast.error("Something went wrong. Please try again.");
            }
        }
    };

    return (
        <div>
            <Typography>
                <TextField
                    placeholder="Enter your email"
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    margin="normal"
                    variant="outlined"
                    InputProps={{
                        endAdornment: (
                            <InputAdornment position="end">
                                <Button type="submit" color="primary" variant="contained" onClick={handleSubscribe}>Subscribe</Button>
                            </InputAdornment>
                        ),
                    }}
                />
            </Typography>
        </div>
    );
};
export default Subscribe;
